export const chapter4Translations = {
  name: "第四章：釘十字架與復活",
  description: "跟隨耶穌受難、死亡與復活的故事",
  spiritualWisdom: "十字架是愛的最終勝利和戰勝罪惡的象徵。復活賜予我們在基督裡新生命的應許。",
  
  levels: {
    40: {
      name: "被捕",
      challenge: "了解耶穌在客西馬尼園被捕的經過",
      
      questions: {
        easy: {
          question: "耶穌在哪個園子裡被捕？",
          options: ["客西馬尼", "伊甸園", "橄欖山", "拿撒勒"],
          correctAnswer: 0,
          difficulty: "easy"
        },
        medium: {
          question: "猶大用什麼記號來出賣耶穌？",
          options: ["握手", "親吻", "一句話", "一個手勢"],
          correctAnswer: 1,
          difficulty: "medium"
        },
        hard: {
          question: "哪位門徒用刀削掉大祭司僕人的耳朵？",
          options: ["雅各", "約翰", "彼得", "安德烈"],
          correctAnswer: 2,
          difficulty: "hard"
        }
      },
      
      hints: [
        "客西馬尼是位於橄欖山腳下的園子",
        "猶大為了三十塊銀子出賣耶穌",
        "耶穌奇蹟般地治癒了僕人的耳朵"
      ],
      
      funFacts: [
        "客西馬尼意思是「榨油坊」，是製作橄欖油的地方",
        "耶穌被捕發生在深夜",
        "耶穌平靜地前往，要求門徒不要用暴力反抗"
      ]
    },

    41: {
      name: "彼得的否認",
      challenge: "了解彼得三次不認耶穌的經過",
      
      questions: {
        easy: {
          question: "彼得否認耶穌多少次？",
          options: ["一次", "兩次", "三次", "四次"],
          correctAnswer: 2,
          difficulty: "easy"
        },
        medium: {
          question: "彼得第三次否認後發生了什麼？",
          options: ["太陽升起", "雞叫了", "閃電劈下", "地震了"],
          correctAnswer: 1,
          difficulty: "medium"
        },
        hard: {
          question: "彼得在哪裡否認耶穌？",
          options: ["在聖殿", "在大祭司的院子", "在彼拉多的官邸", "在客西馬尼"],
          correctAnswer: 1,
          difficulty: "hard"
        }
      },
      
      hints: [
        "耶穌預言了彼得的否認",
        "彼得意識到自己所做的事後痛哭流淚",
        "這一切都發生在同一個晚上"
      ],
      
      funFacts: [
        "耶穌說過「雞叫以前，你要三次不認我」",
        "彼得的否認是人性軟弱和神聖寬恕的有力例證",
        "彼得後來成為教會的偉大領袖"
      ]
    },

    42: {
      name: "耶穌在彼拉多面前",
      challenge: "了解耶穌在羅馬總督面前受審的經過",
      
      questions: {
        easy: {
          question: "彼拉多是誰？",
          options: ["門徒", "羅馬總督", "大祭司", "法利賽人"],
          correctAnswer: 1,
          difficulty: "easy"
        },
        medium: {
          question: "彼拉多在耶穌身上找不到什麼？",
          options: ["智慧", "罪", "勇氣", "力量"],
          correctAnswer: 1,
          difficulty: "medium"
        },
        hard: {
          question: "彼拉多做了什麼來象徵自己的清白？",
          options: ["洗手", "撕裂衣服", "禁食", "禱告"],
          correctAnswer: 0,
          difficulty: "hard"
        }
      },
      
      hints: [
        "彼拉多想要釋放耶穌",
        "群眾要求把耶穌釘十字架",
        "彼拉多屈服於政治壓力"
      ],
      
      funFacts: [
        "彼拉多的妻子警告他不要對耶穌做任何事",
        "洗手在猶太傳統中是清白的象徵",
        "彼拉多的決定顯示了人類正義的失敗"
      ]
    },

    43: {
      name: "巴拉巴還是耶穌",
      challenge: "了解群眾選擇巴拉巴的經過",
      
      questions: {
        easy: {
          question: "巴拉巴是誰？",
          options: ["門徒", "強盜", "祭司", "國王"],
          correctAnswer: 1,
          difficulty: "easy"
        },
        medium: {
          question: "彼拉多在猶太節期可以做什麼？",
          options: ["釋放一名囚犯", "免除稅收", "舉行宴會", "關閉聖殿"],
          correctAnswer: 0,
          difficulty: "medium"
        },
        hard: {
          question: "群眾選擇了誰？",
          options: ["耶穌", "巴拉巴", "兩個都要", "都不要"],
          correctAnswer: 1,
          difficulty: "hard"
        }
      },
      
      hints: [
        "這是逾越節期間",
        "群眾要求把耶穌釘十字架",
        "巴拉巴是個殺人犯和叛亂者"
      ],
      
      funFacts: [
        "巴拉巴這個名字的意思是「父親的兒子」",
        "巴拉巴的釋放象徵著基督的犧牲",
        "我們都是巴拉巴，因耶穌的犧牲而得釋放"
      ]
    },

    44: {
      name: "鞭打與荊棘冠冕",
      challenge: "了解耶穌所受的苦難",
      
      questions: {
        easy: {
          question: "士兵把什麼放在耶穌頭上？",
          options: ["金冠", "荊棘冠冕", "花環", "頭巾"],
          correctAnswer: 1,
          difficulty: "easy"
        },
        medium: {
          question: "士兵如何嘲弄耶穌？",
          options: ["稱他為王", "用石頭打他", "監禁他", "忽視他"],
          correctAnswer: 0,
          difficulty: "medium"
        },
        hard: {
          question: "羅馬鞭子裡含有什麼？",
          options: ["皮帶", "骨頭和金屬碎片", "只有木頭", "繩子"],
          correctAnswer: 1,
          difficulty: "hard"
        }
      },
      
      hints: [
        "鞭打是殘酷的羅馬刑罰",
        "士兵給耶穌穿上紫袍",
        "耶穌默默地忍受了這一切"
      ],
      
      funFacts: [
        "荊棘冠冕象徵著罪的咒詛",
        "紫色是王室的顏色，被用來嘲笑",
        "耶穌的受難應驗了以賽亞的預言"
      ]
    },

    45: {
      name: "前往各各他的路",
      challenge: "了解耶穌如何背負十字架",
      
      questions: {
        easy: {
          question: "耶穌背負什麼？",
          options: ["旗幟", "十字架", "王冠", "寶劍"],
          correctAnswer: 1,
          difficulty: "easy"
        },
        medium: {
          question: "誰幫助耶穌背十字架？",
          options: ["彼得", "約翰", "古利奈人西門", "約瑟"],
          correctAnswer: 2,
          difficulty: "medium"
        },
        hard: {
          question: "各各他是什麼意思？",
          options: ["聖山", "髑髏地", "和平之地", "審判之地"],
          correctAnswer: 1,
          difficulty: "hard"
        }
      },
      
      hints: [
        "耶穌因軟弱而跌倒",
        "婦女在路上哭泣",
        "隊伍穿過城市"
      ],
      
      funFacts: [
        "十字架重約40-50公斤",
        "各各他在城牆外",
        "古利奈人西門來自非洲"
      ]
    },

    46: {
      name: "釘十字架",
      challenge: "了解耶穌被釘十字架的經過",
      
      questions: {
        easy: {
          question: "耶穌和其他多少人一起被釘十字架？",
          options: ["沒有人", "一個", "兩個", "三個"],
          correctAnswer: 2,
          difficulty: "easy"
        },
        medium: {
          question: "耶穌在十字架上說：「父啊，___他們」？",
          options: ["拯救", "赦免", "阻止", "懲罰"],
          correctAnswer: 1,
          difficulty: "medium"
        },
        hard: {
          question: "十字架上的牌子寫著什麼？",
          options: ["罪人", "猶太人的王", "叛徒", "先知"],
          correctAnswer: 1,
          difficulty: "hard"
        }
      },
      
      hints: [
        "耶穌在申初被釘十字架",
        "士兵抽籤分他的衣服",
        "耶穌在十字架上說了七句話"
      ],
      
      funFacts: [
        "牌子用三種語言寫成：希伯來文、拉丁文和希臘文",
        "其中一個強盜在最後一刻悔改了",
        "耶穌把他的母親託付給約翰照顧"
      ]
    },

    47: {
      name: "耶穌之死",
      challenge: "了解耶穌最後的時刻",
      
      questions: {
        easy: {
          question: "耶穌死時發生了什麼？",
          options: ["太陽更明亮", "天變黑了", "下雨了", "出現彩虹"],
          correctAnswer: 1,
          difficulty: "easy"
        },
        medium: {
          question: "聖殿裡什麼東西裂開了？",
          options: ["地板", "幔子", "牆", "天花板"],
          correctAnswer: 1,
          difficulty: "medium"
        },
        hard: {
          question: "耶穌最後的話是什麼？",
          options: ["成了", "我渴了", "父啊，我將我的靈魂交在你手裡", "你為什麼離棄我"],
          correctAnswer: 2,
          difficulty: "hard"
        }
      },
      
      hints: [
        "黑暗持續了三個小時",
        "士兵用槍刺耶穌的肋旁",
        "百夫長說「這真是神的兒子」"
      ],
      
      funFacts: [
        "聖殿的幔子從上到下裂開，不是人手所為",
        "這發生在逾越節期間，正是獻祭羔羊的時候",
        "耶穌的死付清了罪的代價"
      ]
    },

    48: {
      name: "安葬",
      challenge: "了解耶穌的安葬",
      
      questions: {
        easy: {
          question: "耶穌被安放在誰的墳墓裡？",
          options: ["彼得", "亞利馬太的約瑟", "尼哥底母", "拉撒路"],
          correctAnswer: 1,
          difficulty: "easy"
        },
        medium: {
          question: "耶穌的身體用什麼包裹？",
          options: ["紫袍", "金衣", "白色細麻布", "赤身"],
          correctAnswer: 2,
          difficulty: "medium"
        },
        hard: {
          question: "尼哥底母為耶穌的身體帶來了什麼？",
          options: ["油", "沒藥和沉香", "水", "鮮花"],
          correctAnswer: 1,
          difficulty: "hard"
        }
      },
      
      hints: [
        "墳墓是在新鑿的磐石中",
        "有一塊大石頭滾到墓門口",
        "守衛被派來看守墳墓"
      ],
      
      funFacts: [
        "這是富人的墳墓，應驗了以賽亞的預言",
        "安葬是匆忙進行的，因為安息日快到了",
        "約瑟是個暗中的門徒，卻變得勇敢"
      ]
    },

    49: {
      name: "空墳墓",
      challenge: "了解復活早晨的發現",
      
      questions: {
        easy: {
          question: "誰第一個發現墳墓是空的？",
          options: ["彼得", "約翰", "婦女們", "守衛"],
          correctAnswer: 2,
          difficulty: "easy"
        },
        medium: {
          question: "石頭在哪裡？",
          options: ["破碎了", "滾開了", "還在原位", "消失了"],
          correctAnswer: 1,
          difficulty: "medium"
        },
        hard: {
          question: "有多少天使在墳墓裡迎接婦女們？",
          options: ["沒有", "一位", "兩位", "三位"],
          correctAnswer: 2,
          difficulty: "hard"
        }
      },
      
      hints: [
        "這是七日的第一日清晨",
        "婦女們來要膏抹耶穌的身體",
        "天使宣告了好消息"
      ],
      
      funFacts: [
        "婦女們是第一批見證人，這是革命性的細節",
        "彼得和約翰跑到墳墓",
        "光有空墳墓還不夠，耶穌必須顯現"
      ]
    },

    50: {
      name: "耶穌向抹大拉的馬利亞顯現",
      challenge: "了解耶穌第一次顯現",
      
      questions: {
        easy: {
          question: "耶穌復活後第一個向誰顯現？",
          options: ["彼得", "約翰", "抹大拉的馬利亞", "多馬"],
          correctAnswer: 2,
          difficulty: "easy"
        },
        medium: {
          question: "馬利亞起初以為耶穌是誰？",
          options: ["天使", "園丁", "士兵", "法利賽人"],
          correctAnswer: 1,
          difficulty: "medium"
        },
        hard: {
          question: "當馬利亞認出耶穌時，他對她說了什麼？",
          options: ["去告訴", "不要摸我", "不要怕", "相信"],
          correctAnswer: 1,
          difficulty: "hard"
        }
      },
      
      hints: [
        "馬利亞在墳墓旁哭泣",
        "耶穌叫她的名字",
        "他派她去告訴弟兄們"
      ],
      
      funFacts: [
        "耶穌選擇一位婦女作為他第一次顯現的對象",
        "馬利亞成為第一位使徒",
        "她稱呼他「拉波尼」（夫子）"
      ]
    },

    51: {
      name: "在以馬忤斯的路上",
      challenge: "了解耶穌在路上的顯現",
      
      questions: {
        easy: {
          question: "有多少門徒前往以馬忤斯？",
          options: ["一個", "兩個", "三個", "四個"],
          correctAnswer: 1,
          difficulty: "easy"
        },
        medium: {
          question: "門徒什麼時候認出耶穌？",
          options: ["立刻", "擘餅的時候", "在路上", "從未認出"],
          correctAnswer: 1,
          difficulty: "medium"
        },
        hard: {
          question: "耶穌在路上向他們解釋什麼？",
          options: ["未來", "聖經", "律法", "神蹟"],
          correctAnswer: 1,
          difficulty: "hard"
        }
      },
      
      hints: [
        "耶穌像陌生人一樣與他們同行",
        "當他說話時，他們的心如同火熱",
        "當他們認出他時，耶穌就不見了"
      ],
      
      funFacts: [
        "以馬忤斯距離耶路撒冷約11公里",
        "耶穌向他們展示了所有聖經如何論到他",
        "門徒立即跑回耶路撒冷"
      ]
    },

    52: {
      name: "向門徒顯現",
      challenge: "了解耶穌在密室中的顯現",
      
      questions: {
        easy: {
          question: "耶穌顯現時，門徒在哪裡？",
          options: ["在聖殿", "在市場", "在密室中", "在客西馬尼"],
          correctAnswer: 2,
          difficulty: "easy"
        },
        medium: {
          question: "耶穌向門徒展示了什麼？",
          options: ["他的傷痕", "他的面容", "他的衣服", "光"],
          correctAnswer: 0,
          difficulty: "medium"
        },
        hard: {
          question: "第一次時哪位門徒不在場？",
          options: ["彼得", "約翰", "多馬", "雅各"],
          correctAnswer: 2,
          difficulty: "hard"
        }
      },
      
      hints: [
        "因為害怕，門是關著的",
        "耶穌說「願你們平安」",
        "他向他們吹氣說「領受聖靈」"
      ],
      
      funFacts: [
        "耶穌與他們一同吃飯，證明他不是鬼魂",
        "多馬一週後相信了",
        "耶穌在40天內多次顯現"
      ]
    }
  }
};
